/**
 * Get-your-analysis device wizard — multi-step flows mirroring connect-your-device.
 */
(function () {
  var STORED_DEVICE_KEY = 'cyd_selected_device';
  var CONNECT_DEVICE_KEY = 'connect_device_pending';
  var CONNECT_DEVICE_OTHER_LABEL_KEY = 'connect_device_other_label';

  var WHOOP_AUTH_URL =
    'https://us-central1-nutricodeapp-3da5f.cloudfunctions.net/connectWhoop/auth/whoop-from-web';
  var GARMIN_AUTH_URL =
    'https://us-central1-nutricodeapp-3da5f.cloudfunctions.net/connectGarmin/auth/garmin?web=true';
  var OURA_AUTH_URL =
    'https://us-central1-nutricodeapp-3da5f.cloudfunctions.net/connectOura/auth/oura?web=true&sandbox=true';
  var POLAR_AUTH_URL =
    'https://us-central1-nutricodeapp-3da5f.cloudfunctions.net/connectPolar/auth/polar?web=true';
  var COROS_AUTH_URL =
    'https://us-central1-nutricodeapp-3da5f.cloudfunctions.net/connectCoros/auth/coros?web=true';
  var APP_STORE_URL = 'https://apps.apple.com/sg/app/nutricode/id6739556826';
  var PLAY_STORE_URL =
    'https://play.google.com/store/apps/details?id=sg.nutricode.nutricodeapp_android&pcampaignid=web_share';

  var LEAD_MAGNET_TAG = 'lead_magnet_connect_your_device';

  var COPY = {
    device: 'Select your device:',
    email: 'Where should we send the results?',
    demographics: "*We'll use this information to compare your metrics to your demographic.",
    otherName: 'Which device do you have?',
    otherEmail:
      "We're constantly integrating new devices. Enter your email and we'll let you know as soon as we add support for yours.",
    otherThanks: "Thank you. We'll get in touch ASAP"
  };

  var CTA = {
    device: 'Build my free routine →',
    continue: 'Continue →',
    connect: 'Connect my device →',
    waitlist: "We'll get in touch →",
    waiting: 'Waiting for your credentials...',
    selectAnother: 'Select another device'
  };

  function isValidEmail(email) {
    return typeof email === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  }

  function isValidAge(raw) {
    var s = String(raw == null ? '' : raw).trim();
    if (!s || !/^\d{1,3}$/.test(s)) return false;
    var n = parseInt(s, 10);
    return n >= 16 && n <= 99;
  }

  function getStoredEmail() {
    try {
      var mc = localStorage.getItem('emailMailchimp');
      if (mc && String(mc).trim()) return String(mc).trim();
      var cust = localStorage.getItem('customerEmail');
      if (cust && String(cust).trim()) return String(cust).trim();
    } catch (err) {
      console.warn('getStoredEmail', err);
    }
    return '';
  }

  function persistEmail(email) {
    try {
      localStorage.setItem('emailMailchimp', email);
    } catch (err) {
      console.warn('persistEmail', err);
    }
  }

  function persistEmailAndTagLeadMagnet(email, deviceId) {
    persistEmail(email);
    if (typeof globalAddTags !== 'function') return;
    var tags = [LEAD_MAGNET_TAG];
    if (deviceId) tags.push(deviceTag(deviceId));
    globalAddTags(tags, email).catch(function (err) {
      console.error('globalAddTags failed', err);
    });
    trackMeta('leadMagnetConnectDevice');
  }

  function appendWebTrackingToAuthUrl(urlString) {
    if (
      window.NutricodeWebAttribution &&
      typeof window.NutricodeWebAttribution.appendToUrl === 'function'
    ) {
      return window.NutricodeWebAttribution.appendToUrl(urlString);
    }
    return urlString;
  }

  function buildGarminAuthUrl(email, gender, age) {
    var u = new URL(GARMIN_AUTH_URL, window.location.origin);
    if (email) u.searchParams.set('email', email);
    if (gender) u.searchParams.set('gender', gender);
    if (age != null && age !== '') u.searchParams.set('age', String(age));
    return appendWebTrackingToAuthUrl(u.toString());
  }

  function buildWhoopAuthUrl(gender, age) {
    var u = new URL(WHOOP_AUTH_URL, window.location.origin);
    if (gender) u.searchParams.set('gender', gender);
    if (age != null && age !== '') u.searchParams.set('age', String(age));
    return appendWebTrackingToAuthUrl(u.toString());
  }

  function buildPolarAuthUrl(email) {
    var u = new URL(POLAR_AUTH_URL, window.location.origin);
    if (email) u.searchParams.set('email', email);
    return appendWebTrackingToAuthUrl(u.toString());
  }

  /** COROS doesn't share gender/age: gender only as male|female, age only as a whole number. */
  function buildCorosAuthUrl(email, gender, age) {
    var u = new URL(COROS_AUTH_URL, window.location.origin);
    if (email) u.searchParams.set('email', email);
    if (gender === 'male' || gender === 'female') u.searchParams.set('gender', gender);
    if (age != null && age !== '') u.searchParams.set('age', String(age));
    return appendWebTrackingToAuthUrl(u.toString());
  }

  function deviceTag(deviceId) {
    return 'connect_device_' + String(deviceId || '').replace(/-/g, '_');
  }

  function trackMeta(eventName) {
    if (typeof window.trackMeta === 'function') {
      window.trackMeta(eventName);
    } else if (typeof fbq === 'function') {
      fbq('trackCustom', eventName);
    }
  }

  function trackGoogle(eventName, params) {
    if (typeof window.trackGoogle === 'function') {
      window.trackGoogle(eventName, params || {});
    } else if (typeof gtag === 'function') {
      gtag('event', eventName, params || {});
    }
  }

  function gtagDeviceName(slug) {
    return String(slug || '').replace(/-/g, '_');
  }

  function trackConnectDeviceInitiated(deviceName) {
    trackMeta('connectDeviceInitiated');
    trackGoogle('connectDeviceInitiated', deviceName ? { device_name: gtagDeviceName(deviceName) } : {});
  }

  function isApplePlatform() {
    var platform = (navigator.platform || '').toLowerCase();
    var ua = (navigator.userAgent || '').toLowerCase();
    return /iphone|ipad|ipod/.test(ua) || platform.indexOf('mac') !== -1;
  }

  function shakeQuestion(el) {
    if (!el) return;
    el.classList.remove('gya-step-question--shake');
    void el.offsetWidth;
    el.classList.add('gya-step-question--shake');
    window.setTimeout(function () {
      el.classList.remove('gya-step-question--shake');
    }, 480);
  }

  function scrollToElement(el) {
    if (!el || !el.getBoundingClientRect) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
      });
    });
  }

  function openAuthInNewTab(url) {
    var win = window.open(url, '_blank', 'noopener,noreferrer');
    if (win) {
      try {
        win.opener = null;
      } catch (err) {}
    }
    return win;
  }

  function Wizard(root, sectionId) {
    this.root = root;
    this.sectionId = sectionId;
    this.device = '';
    this.state = { email: '', gender: '', age: '', otherName: '' };
    this.history = [];
    this.questionEl = root.querySelector('.gya-step-question');
    this.ctaEl = root.querySelector('[data-gya-cta]');
    this.backEl = root.querySelector('[data-gya-back]');
    this.panels = {
      device: root.querySelector('[data-gya-panel="device"]'),
      email: root.querySelector('[data-gya-panel="email"]'),
      demographics: root.querySelector('[data-gya-panel="demographics"]'),
      'other-name': root.querySelector('[data-gya-panel="other-name"]'),
      'other-email': root.querySelector('[data-gya-panel="other-email"]')
    };
    this.bulletsEl = root.querySelector('.gya-hero-bullets');
    this.applePromo = root.querySelector('[data-gya-apple-app-promo]');
    this.garminModal = document.getElementById('gya-garmin-modal-' + sectionId);
    this.currentPanel = 'device';
    this.otherWaitlistSubmitted = false;
    this.bind();
    this.restoreDeviceSelection();
    this.updateBackBtn();
  }

  Wizard.prototype.restoreDeviceSelection = function () {
    var form = this.panels.device;
    if (!form) return;
    var radios = form.querySelectorAll('input[type="radio"][name="gya-device-' + this.sectionId + '"]');
    try {
      var stored = localStorage.getItem(STORED_DEVICE_KEY);
      if (!stored) return;
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].value === stored) {
          radios[i].checked = true;
          break;
        }
      }
    } catch (err) {
      console.warn('restoreDeviceSelection', err);
    }
  };

  Wizard.prototype.setQuestion = function (text) {
    if (this.questionEl) this.questionEl.textContent = text;
  };

  Wizard.prototype.setCta = function (text) {
    if (this.ctaEl) this.ctaEl.textContent = text;
  };

  Wizard.prototype.clearCtaWaitingTimer = function () {
    if (this.ctaWaitingTimer != null) {
      window.clearTimeout(this.ctaWaitingTimer);
      this.ctaWaitingTimer = null;
    }
  };

  Wizard.prototype.restoreCtaFromWaiting = function (button) {
    var btn = button || this.ctaEl;
    if (!btn) return;
    if (btn.dataset.gyaOriginalText != null) {
      btn.textContent = btn.dataset.gyaOriginalText;
      delete btn.dataset.gyaOriginalText;
    }
    btn.disabled = false;
    btn.style.opacity = '';
    this.updateBackBtn();
  };

  Wizard.prototype.setCtaWaiting = function (button) {
    var self = this;
    var btn = button || this.ctaEl;
    if (!btn) return;
    this.clearCtaWaitingTimer();
    if (btn.dataset.gyaOriginalText == null) {
      btn.dataset.gyaOriginalText = btn.textContent;
    }
    btn.textContent = CTA.waiting;
    btn.disabled = true;
    btn.style.opacity = '0.8';
    if (this.backEl) this.backEl.setAttribute('hidden', '');
    this.ctaWaitingButton = btn;
    this.ctaWaitingTimer = window.setTimeout(function () {
      self.ctaWaitingTimer = null;
      self.restoreCtaFromWaiting(self.ctaWaitingButton);
      self.ctaWaitingButton = null;
    }, 10000);
  };

  Wizard.prototype.openDeviceAuth = function (url, button) {
    this.setCtaWaiting(button);
    openAuthInNewTab(url);
  };

  Wizard.prototype.showPanel = function (name) {
    var key;
    for (key in this.panels) {
      if (!this.panels[key]) continue;
      if (key === name) {
        this.panels[key].removeAttribute('hidden');
      } else {
        this.panels[key].setAttribute('hidden', '');
      }
    }
    this.currentPanel = name;
    this.updateBackBtn();
  };

  Wizard.prototype.prefillEmail = function (input) {
    if (!input) return;
    var stored = getStoredEmail();
    if (stored && !String(input.value || '').trim()) input.value = stored;
  };

  /* Save current step state before advancing forward */
  Wizard.prototype.pushHistory = function () {
    this.history.push({
      panel: this.currentPanel,
      question: this.questionEl ? this.questionEl.textContent : '',
      cta: this.ctaEl ? this.ctaEl.textContent : '',
      bulletsHidden: this.bulletsEl ? this.bulletsEl.hasAttribute('hidden') : false
    });
    this.updateBackBtn();
  };

  Wizard.prototype.updateBackBtn = function () {
    if (!this.backEl) return;
    if (this.currentPanel === 'device' || this.history.length === 0) {
      this.backEl.setAttribute('hidden', '');
    } else {
      this.backEl.removeAttribute('hidden');
    }
  };

  Wizard.prototype.goBack = function () {
    if (!this.history.length) return;
    var prev = this.history.pop();

    if (this.questionEl) {
      this.questionEl.textContent = prev.question;
      this.questionEl.removeAttribute('hidden');
    }
    if (this.ctaEl) {
      this.ctaEl.textContent = prev.cta;
      this.ctaEl.removeAttribute('hidden');
    }
    if (this.bulletsEl) {
      if (prev.bulletsHidden) {
        this.bulletsEl.setAttribute('hidden', '');
      } else {
        this.bulletsEl.removeAttribute('hidden');
      }
    }
    if (this.applePromo) this.applePromo.setAttribute('hidden', '');

    this.showPanel(prev.panel);
    this.updateBackBtn();
  };

  Wizard.prototype.resetToDeviceSelection = function () {
    this.clearCtaWaitingTimer();
    this.ctaWaitingButton = null;
    this.device = '';
    this.state = { email: '', gender: '', age: '', otherName: '' };
    this.history = [];
    this.otherWaitlistSubmitted = false;

    this.setQuestion(COPY.device);
    this.setCta(CTA.device);

    if (this.ctaEl) {
      this.ctaEl.removeAttribute('hidden');
      this.ctaEl.disabled = false;
      this.ctaEl.style.opacity = '';
      delete this.ctaEl.dataset.gyaOriginalText;
    }

    if (this.bulletsEl) this.bulletsEl.removeAttribute('hidden');
    if (this.applePromo) this.applePromo.setAttribute('hidden', '');

    var otherEmailPanel = this.panels['other-email'];
    var otherEmailField = otherEmailPanel ? otherEmailPanel.querySelector('.gya-field') : null;
    var otherEmailInput = this.root.querySelector('[data-gya-other-email]');
    var otherNameInput = this.root.querySelector('[data-gya-other-name]');
    var thanks = this.root.querySelector('[data-gya-other-thanks]');
    if (otherEmailField) otherEmailField.removeAttribute('hidden');
    if (otherEmailInput) otherEmailInput.value = '';
    if (otherNameInput) otherNameInput.value = '';
    if (thanks) thanks.setAttribute('hidden', '');

    var form = this.panels.device;
    if (form) {
      var radios = form.querySelectorAll('input[type="radio"][name="gya-device-' + this.sectionId + '"]');
      for (var i = 0; i < radios.length; i++) {
        radios[i].checked = false;
      }
    }

    try {
      localStorage.removeItem(STORED_DEVICE_KEY);
      localStorage.removeItem(CONNECT_DEVICE_KEY);
      localStorage.removeItem(CONNECT_DEVICE_OTHER_LABEL_KEY);
    } catch (err) {
      console.warn('reset device selection', err);
    }

    this.showPanel('device');
  };

  Wizard.prototype.returnToDeviceQuestion = function (options) {
    var opts = options || {};
    this.history = [];
    this.setQuestion(COPY.device);
    this.setCta(CTA.device);

    if (this.ctaEl) {
      this.ctaEl.removeAttribute('hidden');
      this.ctaEl.disabled = false;
      this.ctaEl.style.opacity = '';
      delete this.ctaEl.dataset.gyaOriginalText;
    }

    if (this.bulletsEl) this.bulletsEl.removeAttribute('hidden');
    if (!opts.keepApplePromo && this.applePromo) this.applePromo.setAttribute('hidden', '');

    this.showPanel('device');
  };

  Wizard.prototype.goToEmailStep = function () {
    this.pushHistory();
    this.setQuestion(COPY.email);
    this.setCta(this.device === 'apple-watch' ? CTA.connect : CTA.continue);
    if (this.bulletsEl) this.bulletsEl.setAttribute('hidden', '');
    if (this.applePromo) this.applePromo.setAttribute('hidden', '');
    this.showPanel('email');
    this.prefillEmail(this.root.querySelector('[data-gya-email]'));
  };

  Wizard.prototype.onDeviceSubmit = function () {
    var form = this.panels.device;
    var selected = form.querySelector('input[type="radio"][name="gya-device-' + this.sectionId + '"]:checked');
    if (!selected) {
      shakeQuestion(this.questionEl);
      return;
    }
    this.device = selected.value;
    try {
      localStorage.setItem(STORED_DEVICE_KEY, this.device);
      localStorage.setItem(CONNECT_DEVICE_KEY, this.device);
    } catch (err) {
      console.warn('persist device', err);
    }

    if (this.device === 'other') {
      this.pushHistory();
      this.setQuestion(COPY.otherName);
      this.setCta(CTA.continue);
      if (this.bulletsEl) this.bulletsEl.setAttribute('hidden', '');
      this.showPanel('other-name');
      return;
    }

    this.goToEmailStep();
  };

  Wizard.prototype.onEmailSubmit = function () {
    var input = this.root.querySelector('[data-gya-email]');
    var email = input ? String(input.value || '').trim() : '';
    if (!isValidEmail(email)) {
      if (input) input.focus();
      return;
    }
    this.state.email = email;
    persistEmailAndTagLeadMagnet(email, this.device);

    if (this.device === 'apple-watch') {
      trackConnectDeviceInitiated(this.device);
      this.returnToDeviceQuestion({ keepApplePromo: true });
      this.showApplePromo();
      return;
    }
    if (this.device === 'oura') {
      trackConnectDeviceInitiated(this.device);
      this.openDeviceAuth(appendWebTrackingToAuthUrl(OURA_AUTH_URL));
      return;
    }
    if (this.device === 'polar') {
      trackConnectDeviceInitiated(this.device);
      this.openDeviceAuth(buildPolarAuthUrl(email));
      return;
    }
    if (this.device === 'garmin' || this.device === 'whoop' || this.device === 'coros') {
      this.pushHistory();
      this.setQuestion(COPY.demographics);
      this.setCta(CTA.connect);
      var corosTip = this.root.querySelector('[data-gya-coros-tip]');
      if (corosTip) corosTip.hidden = this.device !== 'coros';
      this.showPanel('demographics');
    }
  };

  Wizard.prototype.onDemographicsSubmit = function () {
    var genderEl = this.root.querySelector('[data-gya-gender]');
    var ageEl = this.root.querySelector('[data-gya-age]');
    var ageHint = this.root.querySelector('[data-gya-age-hint]');
    var gender = genderEl ? String(genderEl.value || '').trim() : '';
    var ageRaw = ageEl ? String(ageEl.value || '').trim() : '';

    if (!gender) {
      if (genderEl) genderEl.focus();
      return;
    }
    if (!isValidAge(ageRaw)) {
      if (ageHint) {
        ageHint.textContent = 'Please enter an age between 16 and 99.';
        ageHint.removeAttribute('hidden');
      }
      if (ageEl) ageEl.focus();
      return;
    }
    if (ageHint) {
      ageHint.textContent = '';
      ageHint.setAttribute('hidden', '');
    }

    this.state.gender = gender;
    this.state.age = parseInt(ageRaw, 10);
    try {
      localStorage.setItem('gender', gender);
    } catch (err) {
      console.warn('[gya-wizard] Unable to persist gender', err);
    }

    if (this.device === 'whoop') {
      trackConnectDeviceInitiated(this.device);
      this.openDeviceAuth(buildWhoopAuthUrl(gender, this.state.age));
      return;
    }
    if (this.device === 'garmin') {
      trackConnectDeviceInitiated(this.device);
      this.openGarminModal();
      return;
    }
    if (this.device === 'coros') {
      trackConnectDeviceInitiated(this.device);
      this.openDeviceAuth(buildCorosAuthUrl(this.state.email, gender, this.state.age));
    }
  };

  Wizard.prototype.onOtherNameSubmit = function () {
    var input = this.root.querySelector('[data-gya-other-name]');
    var name = input ? String(input.value || '').trim() : '';
    if (!name) {
      if (input) input.focus();
      return;
    }
    this.state.otherName = name;
    try {
      localStorage.setItem(CONNECT_DEVICE_OTHER_LABEL_KEY, name);
    } catch (err) {
      console.warn('persist other label', err);
    }
    this.pushHistory();
    this.setQuestion(COPY.otherEmail);
    this.setCta(CTA.waitlist);
    this.showPanel('other-email');
    this.prefillEmail(this.root.querySelector('[data-gya-other-email]'));
  };

  Wizard.prototype.onOtherEmailSubmit = function () {
    var input = this.root.querySelector('[data-gya-other-email]');
    var email = input ? String(input.value || '').trim() : '';
    if (!isValidEmail(email)) {
      if (input) input.focus();
      return;
    }
    persistEmail(email);
    var tag = deviceTag('other');
    var deviceNameTags = (this.state.otherName || '')
      .split(',')
      .map(function (n) { return n.trim().toLowerCase().replace(/\s+/g, '_'); })
      .filter(Boolean)
      .map(function (n) { return 'connect_device_' + n; });
    if (typeof globalAddTags === 'function') {
      globalAddTags([LEAD_MAGNET_TAG, tag, 'pending_device'].concat(deviceNameTags), email).catch(function (err) {
        console.error('globalAddTags failed', err);
      });
    }

    this.otherWaitlistSubmitted = true;
    this.history = [];
    this.setQuestion(COPY.otherThanks);
    this.setCta(CTA.selectAnother);

    if (this.ctaEl) {
      this.ctaEl.disabled = false;
      this.ctaEl.style.opacity = '';
      this.ctaEl.removeAttribute('hidden');
    }
    if (this.backEl) this.backEl.setAttribute('hidden', '');

    var panel = this.panels['other-email'];
    var field = panel ? panel.querySelector('.gya-field') : null;
    var thanks = this.root.querySelector('[data-gya-other-thanks]');
    if (field) field.setAttribute('hidden', '');
    if (thanks) thanks.setAttribute('hidden', '');

    this.showPanel('');
    this.currentPanel = 'other-thanks';
    this.updateBackBtn();
  };

  Wizard.prototype.showApplePromo = function () {
    if (this.applePromo) this.applePromo.removeAttribute('hidden');
    scrollToElement(this.applePromo);
  };

  Wizard.prototype.openGarminModal = function () {
    var modal = this.garminModal;
    if (!modal) {
      this.openDeviceAuth(buildGarminAuthUrl(this.state.email, this.state.gender, this.state.age));
      return;
    }
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
    });
    document.body.classList.add('gya-modal-open');
    var video = modal.querySelector('[data-gya-garmin-video]');
    if (video) {
      try {
        video.currentTime = 0.5;
        video.play().catch(function () {});
      } catch (e) {}
    }
  };

  Wizard.prototype.closeGarminModal = function () {
    var modal = this.garminModal;
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('gya-modal-open');
    var video = modal.querySelector('[data-gya-garmin-video]');
    if (video) {
      try {
        video.pause();
      } catch (e) {}
    }
    window.setTimeout(function () {
      if (!modal.classList.contains('is-open')) modal.setAttribute('hidden', '');
    }, 280);
  };

  Wizard.prototype.redirectGarmin = function () {
    this.closeGarminModal();
    this.openDeviceAuth(buildGarminAuthUrl(this.state.email, this.state.gender, this.state.age), this.ctaEl);
  };

  Wizard.prototype.onCtaClick = function (e) {
    e.preventDefault();
    if (this.currentPanel === 'device') this.onDeviceSubmit();
    else if (this.currentPanel === 'email') this.onEmailSubmit();
    else if (this.currentPanel === 'demographics') this.onDemographicsSubmit();
    else if (this.currentPanel === 'other-name') this.onOtherNameSubmit();
    else if (this.currentPanel === 'other-email') this.onOtherEmailSubmit();
    else if (this.currentPanel === 'other-thanks') this.resetToDeviceSelection();
  };

  Wizard.prototype.bindAppleStoreLinks = function () {
    var promo = this.applePromo;
    if (!promo || promo.dataset.gyaStoreBound === '1') return;
    promo.dataset.gyaStoreBound = '1';
    promo.addEventListener('click', function (ev) {
      var hit = ev.target.closest('[data-gya-store-smart-link]');
      if (!hit || !promo.contains(hit)) return;
      ev.preventDefault();
      var url = isApplePlatform() ? APP_STORE_URL : PLAY_STORE_URL;
      var win = window.open(url, '_blank');
      if (win) {
        try {
          win.opener = null;
        } catch (err) {}
      }
    });
  };

  Wizard.prototype.bindGarminModal = function () {
    var modal = this.garminModal;
    var self = this;
    if (!modal || modal.dataset.gyaBound === '1') return;
    modal.dataset.gyaBound = '1';
    modal.querySelectorAll('[data-gya-garmin-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        self.closeGarminModal();
      });
    });
    var cont = modal.querySelector('[data-gya-garmin-continue]');
    if (cont) {
      cont.addEventListener('click', function () {
        self.redirectGarmin();
      });
    }
  };

  Wizard.prototype.bind = function () {
    var self = this;
    if (this.ctaEl) {
      this.ctaEl.addEventListener('click', function (e) {
        self.onCtaClick(e);
      });
    }
    if (this.backEl) {
      this.backEl.addEventListener('click', function () {
        self.goBack();
      });
    }
    var ageEl = this.root.querySelector('[data-gya-age]');
    var ageHint = this.root.querySelector('[data-gya-age-hint]');
    if (ageEl && ageHint) {
      ageEl.addEventListener('input', function () {
        if (isValidAge(ageEl.value)) {
          ageHint.textContent = '';
          ageHint.setAttribute('hidden', '');
        }
      });
    }
    this.bindAppleStoreLinks();
    this.bindGarminModal();
  };

  function boot() {
    var root = document.getElementById('bs-metric-form-get');
    if (!root || root.dataset.gyaWizardBound === '1') return;
    root.dataset.gyaWizardBound = '1';
    var sectionId = root.getAttribute('data-section-id');
    if (!sectionId) return;
    new Wizard(root, sectionId);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
